module.exports = __webpack_public_path__ + "static/media/light-theme-max-speed.c290d9fa.svg";